import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { School } from "lucide-react";
import { api } from "@/lib/api";
import { useL } from "@/lib/useL";

let cached = null;

// Link to the school quote page, shown only once the offer is opened in Admin.
export function SchoolOfferLink({ variant = "card", testid = "school-offer-link" }) {
  const L = useL();
  const [open, setOpen] = useState(cached);
  useEffect(() => {
    if (cached === null) api.get("/school/offer").then(({ data }) => { cached = !!data.open; setOpen(cached); }).catch(() => {});
  }, []);
  if (!open) return null;
  if (variant === "inline") {
    return <Link to="/etablissements/devis" data-testid={testid} className="text-muted-foreground hover:text-foreground transition-colors">{L("Offre établissement", "School offer")}</Link>;
  }
  return (
    <Link to="/etablissements/devis" data-testid={testid}
      className="mt-6 flex items-center gap-3 border border-[#002FA7] p-4 hover:bg-[#002FA7]/5 transition-colors">
      <School className="w-5 h-5 text-[#002FA7] shrink-0" />
      <span className="text-sm">
        <b>{L("Offre établissement", "School offer")}</b> · {L("500 à 3 000 crédits, devis PDF, paiement par virement ou carte.", "500 to 3,000 credits, PDF quote, payment by bank transfer or card.")}
      </span>
    </Link>
  );
}

export default SchoolOfferLink;
